import { apiClient } from './api';
import {
  HealthResponse,
  Configuration,
  ProcessingParams,
  QueryParams,
  LookupInsertData,
  LookupRecord,
  LogRecord,
  ResultsRecord,
  UnprocessedRecord,
  AppLogParams,
  AppLogResponse,
  ApiResponse,
  ProcessedStatsResponse,
} from '../types/api';

export const rasService = {
  // Health Check
  async getHealth(): Promise<HealthResponse> {
    return apiClient.get<HealthResponse>('/health');
  },

  // Processed Stats
  async getProcessedStats(hours: number = 24): Promise<ProcessedStatsResponse> {
    return apiClient.post<ProcessedStatsResponse>('/processed_stats', { hours });
  },

  // Configuration Management
  async getConfiguration(): Promise<Configuration> {
    return apiClient.get<Configuration>('/setting-get');
  },

  async updateConfiguration(settings: Partial<Configuration>): Promise<ApiResponse> {
    return apiClient.post('/setting-update', settings);
  },

  async resetConfiguration(): Promise<ApiResponse> {
    return apiClient.post('/setting-reset', {});
  },

  // Data Processing
  async processRaceData(params: ProcessingParams = {}): Promise<ApiResponse> {
    return apiClient.post('/caller', params);
  },

  async browseResults(queryParams: QueryParams): Promise<ApiResponse<ResultsRecord[]>> {
    return apiClient.post('/results-browsing', queryParams);
  },

  async queryUnprocessed(queryParams: QueryParams): Promise<ApiResponse<UnprocessedRecord[]>> {
    return apiClient.post('/unprocessed', queryParams);
  },

  // Querying
  async queryLogs(queryParams: QueryParams): Promise<ApiResponse<LogRecord[]>> {
    return apiClient.post('/log', queryParams);
  },

  async queryAppLogs(params: AppLogParams): Promise<AppLogResponse> {
    return apiClient.post('/app-logs', params);
  },

  async queryLookup(queryParams: QueryParams): Promise<ApiResponse<LookupRecord[]>> {
    return apiClient.post('/lookup', queryParams);
  },

  // Lookup Management
  async insertLookup(data: LookupInsertData): Promise<ApiResponse<LookupRecord>> {
    return apiClient.post('/lookup-insert', data);
  },

  async deleteLookup(id: number): Promise<ApiResponse<LookupRecord>> {
    return apiClient.delete(`/lookup-delete/${id}`);
  },
};